import Fuse from "fuse.js";
import removeMd from "remove-markdown";
import _ from "lodash";

import state from "../state";
import{isVisible, getRealName} from "./utils";

let currentIndex = null;
let initializedActivity = null;
let searchableActivity = null;
let itemToSection = {};
let sectionToList = {};
let docsMap = {};
let topLevel = null;

export function initCurrentActivity() {
	let currentActivity = state.get(["activity"]);
	if (currentActivity && initializedActivity !== currentActivity.id) {
		topLevel = null;
		currentActivity = _.cloneDeep(currentActivity);
		itemToSection = {};
		sectionToList = {};
		const docs = [];


		if (currentActivity.children && _.isArray(currentActivity.children)) {
			currentActivity.children.forEach(list => {
				if (list.children && _.isArray(list.children) && (!list.hasOwnProperty("excludeFromNavigation") || !list.excludeFromNavigation)) {
					const { guid, navTitle, name, insertedByNormalization } = list;
					if (!insertedByNormalization) {
						topLevel = "list";
						const title = navTitle ? navTitle : getRealName(name);
						const doc = {
							guid,
							title,
							type: "list"
						};
						docs.push(doc);
						docsMap[guid] = doc;
					}
					
					list.children.forEach(section => {
						if (section.children && _.isArray(section.children) && (!section.hasOwnProperty("excludeFromNavigation") || !section.excludeFromNavigation)) {
							const { guid, navTitle, name, insertedByNormalization } = section;
							if (!insertedByNormalization) {
								if (!topLevel) {
									topLevel = "section";
								}
								const title = navTitle ? navTitle : getRealName(name);
								const doc = {
									guid,
									title,
									type: "section"
								};
								docs.push(doc);
								docsMap[guid] = doc;
							}
							section.children.forEach(item => {
								if (!item.hasOwnProperty("excludeFromNavigation") || !item.excludeFromNavigation) {
									if (!topLevel) {
										topLevel = "item";
									}
									const { guid, label1, label2, title } = item;
									itemToSection[guid] = section.guid;
									const doc = {
										guid,
										label1: removeMd(label1),
										label2: removeMd(label2),
										title,
										type: "item"
									};
									docs.push(doc);
									docsMap[guid] = doc;
								}
							});
							sectionToList[section.guid] = list.guid;
						}
					});
				}
			});
		}
		initializedActivity = currentActivity.id;
		searchableActivity = currentActivity;
		const options = {
			shouldSort: true,
			includeMatches: true,
			// includeScore: true,
			tokenize: true,
			maxPatternLength: 32,
			minMatchCharLength: 3,
			// findAllMatches: true,
			threshold: 0.35,
			location: 0,
			distance: 50,
			keys: [
				"label1",
				"label2",
				"title"
			],
			id: "guid"
		};
		currentIndex = new Fuse(docs, options);
	}
}

export function search(query) {
	let results = {
		map: "all"
	};
	if (currentIndex && query && _.isString(query) && query.length > 2) {
		const _results = currentIndex.search(query);
		console.log(_results);
		if (_results) {
			results.raw = _results;
			results.map = {};
			_results.forEach(res => {
				results.map[res.item] = true;
			});
		}
	}
	console.log("Got results", query, results);
	return results;
}

export function updateSearchableActivity(path, value) {
	if (searchableActivity) {
		try {
			console.log("Setting", path, value);
			_.set(searchableActivity, path, value);
		} catch (e) {
			console.warn(e);
		}
	}
}

export function getFilteredCurrentActivity(query) {
	initCurrentActivity();
	let result = search(query);
	if (result.map) {
		
		let res = _.assign({}, _.omit(searchableActivity, ["children"]));
		res.children = [];

		const isFullResultSet = result.map === "all";

		const availableLists = {};
		const availableSections = {};

		if (!isFullResultSet) {
			_.keys(result.map).forEach(guid => {

				let entity = docsMap[guid];
				const { type } = entity;

				switch (type) {
					case "item": {
						let availableSectionGuid = itemToSection[guid];
						let availableListGuid = sectionToList[availableSectionGuid];
						availableSections[availableSectionGuid] = true;
						availableLists[availableListGuid] = true;
						break;
					}
					case "section": {
						let availableSectionGuid = guid;
						let availableListGuid = sectionToList[availableSectionGuid];
						availableSections[availableSectionGuid] = true;
						availableLists[availableListGuid] = true;
						break;
					}
					case "list": {
						let availableListGuid = guid;
						availableLists[availableListGuid] = true;
						break;
					}
					default: {
						console.error("Unknown entity type", type);
						}
				}
				
			});
		}

		searchableActivity.children.forEach(list => {
			if (isFullResultSet || availableLists[list.guid]) {
				// Continue with this list

				let newList = _.assign({}, _.omit(list, "children"));
				newList.children = [];
				newList.visible = isVisible(list);

				list.children.forEach(section => {
					if (isFullResultSet || availableSections[section.guid]) {
						// Continue with this section
						let newSection = _.assign({}, _.omit(section, "children"));
						newSection.visible = newList.visible &&isVisible(section);
						newSection.children = [];

						section.children.forEach(item => {
							if (isFullResultSet || result.map[item.guid]) {
								item.visible = newList.visible && newSection.visible && isVisible(item);
								newSection.children.push(item);
							}
						});

						newList.children.push(newSection);
					}
				});
				res.children.push(newList);
			}
		});
		return res;
	} else {
		return searchableActivity;
	}
}

export function getTopLevel() {
	return topLevel;
}